<template>
    <div v-if="isActive" class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-content">
            <div class="box">
                <article class="media">
                    <div class="media-content">
                        <div class="content">
                            <h3 class="title has-text-danger has-text-centered">Multi Invoice #{{ multiInvoiceId }}</h3>
                            <div class="display-flex multi-invoice-options ">
                                <h4 class="amount-left">Remaining amount: {{ getCurrency }}{{ remainingAmount |
                                    formatNumber }}</h4>
                                <div class="multi-invoice-deposit">
                                    <div class="field select is-fullwidth select-deposit">
                                        <div class="control">
                                            <select v-model="deposit" v-on:change="depositPayment()">
                                                <option selected :value="null" disabled>Deposit</option>
                                                <option value="100%">Pay in full</option>
                                                <option value="50%-50%">50%</option>
                                                <option value="30%-70%">30%</option>
                                                <option value="custom">Custom</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="theme-table-container table-container center-column w-100">
                                <table class="theme-table table is-responsive-table is-fullwidth is-scrollable is-striped">
                                    <thead>
                                    <tr>
                                        <th><span @click="setOrder('manager_id')" class="link">Invoice #</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Issue Date</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Chassis</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Due Amount</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Used Amount</span></th>
                                        <th><span @click="setOrder('manager_id')" class="link">Deposit</span></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <unpaid-invoice-table-row v-for="(invoice, index) in unpaidInvoices"
                                                              :invoice="invoice" :invoiceDeposit="invoice.deposit" :invoiceAmountUsed="invoice.amount_used" :action="'add'"
                                                              :transactionTotals="transactionTotals" :amount="amount"></unpaid-invoice-table-row>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <button class="modal-close is-large" aria-label="close" @click="closeModal"></button>
    </div>
</template>

<script>
    import UnpaidInvoiceTableRow from "./UnpaidInvoiceTableRow";

    export default {
        components: {UnpaidInvoiceTableRow},
        props: ['amount'],
        data() {
            return {
                deposit: ''
                //unpaidInvoices: [],
            }
        },
        computed: {
            remainingAmount: function () {
                return this.amount - this.getAmountUsed
            },
            isActive() {
                return this.$store.getters.getMultiInvoicesModal
            },
            transactionTotals: function () {
                return this.$store.getters.getTransactionTotals
            },
            multiInvoiceId() {
                return this.$store.getters.getCurrentMultiInvoiceId
            },
            unpaidInvoices() {
                let unpaid_invoices = this.$store.getters.getUnpaidAllInvoices;
                let currentMultiInvoices = this.$store.getters.getCurrentMultiInvoices;
                let return_invoice = unpaid_invoices.filter((invoice) => {
                    if (currentMultiInvoices.indexOf(invoice.id) > -1) {
                        return true;
                    }
                    return false
                });

                return return_invoice;
            },
            getAmountUsed: function () {
                let invoiceAmountUsed = this.$store.getters.getInvoiceAmountUsed
                let used_amount = 0;
                invoiceAmountUsed.forEach((invObj) => {
                    used_amount += Number(invObj.amount_used)
                })

                return used_amount
            },
            getCurrency: function () {
                return this.$store.getters.getTransactionTotals.currency == 2 ? '$' : '¥'
            },
        },
        methods: {
            closeModal() {
                this.$store.commit('setMultiInvoicesModal', false)
            },
            depositPayment(){
                this.unpaidInvoices.forEach((invoice) => {
                    let deposit = this.deposit;
                    let used_amount = 0;

                    let balance = Number(invoice.balance_due);
                    let paid_amount = Number(invoice.paid_amount);
                    if (this.deposit == '100%') {
                        if (invoice.currency == 1 || invoice.currency == null) {
                            used_amount = balance - paid_amount
                        } else {
                            used_amount = Math.round((balance - paid_amount) * invoice.rate);
                        }
                    } else if (this.deposit == '50%-50%') {
                        if (invoice.currency == 1 || invoice.currency == null) {
                            used_amount = Math.round((balance - paid_amount) * 50 / 100)
                        } else {
                            used_amount = Math.round((balance - paid_amount) * (50 / 100) * invoice.rate);
                        }
                    } else if (this.deposit == '30%-70%') {
                        if (invoice.currency == 1 || invoice.currency == null) {
                            used_amount = Math.round((balance - paid_amount) * 30 / 100)
                        } else {
                            used_amount = Math.round((balance - paid_amount) * (30 / 100) * invoice.rate);
                        }
                    } else if(this.deposit == 'custom'){
                        deposit = '';
                    }
                    invoice.amount_used = used_amount;
                    invoice.deposit = this.deposit;
                    this.$store.commit('updateUnpaidAllInvoices', invoice)
                    this.$store.commit('setInvoiceAmountUsed', {'invoice_id': invoice.id, 'amount_used': used_amount, 'deposit': this.deposit})
                })
            }
        }
    }
</script>

<style scoped>
    .modal-content {
        width: 60%;
    }

    .multi-invoice-options {
        justify-content: space-between;
    }
</style>


// WEBPACK FOOTER //
// src/components/Banking/UnpaidMultiInvoicesModal.vue